import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta } from '@angular/platform-browser';



@Component({
    selector: 'app-custom-molded-rubber-gasket-products',
    templateUrl: './custom-molded-rubber-gasket-products.component.html',
    styleUrls: [
        './custom-molded-rubber-gasket-products.component.scss'
    ],
    standalone: false
})
export class CustomMoldedRubberGasketProductsComponent implements OnInit {

  constructor(
    private meta: Meta,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Custom Products Index", "data-type": "string"});
  }

  ngOnInit() {
  }

}
